import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const widgetLogState = atom<boolean>({
  key: 'widgetLogState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
